import { useCallback } from "react";
import { useField } from "formik";
import {
  SharedserviceMelcoModelsDesignListItem,
  useDrawerSelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export const useDesignConfiguration = () => {
  const { t } = useTranslation();

  const [{ value: selectedDesignId }, , { setValue: setDesignId }] = useField<
    string | undefined
  >("outputs[0].design_id");

  const designIdField = useDrawerSelectField<string | undefined>(
    "outputs[0].design_id",
    t("designMappings.detail.form.label.design_id")
  );

  const onDesignSelect = useCallback(
    (selectedDesign: SharedserviceMelcoModelsDesignListItem) => {
      setDesignId(selectedDesign.id ?? undefined);
    },
    [setDesignId]
  );

  return {
    selectedDesignId,
    designIdField,
    onDesignSelect,
  };
};
